import React, { useState } from "react";
import Popup from "reactjs-popup";
import "../App.css";
import { Button } from "reactstrap";

import { ToastContainer } from "react-toastify";

export const Picker = ({ title, items, onSubmit, button }) => {
  const [selected, setSelected] = useState();

  return (
    <Popup
      contentStyle={{ width: 500, height: 500 }}
      modal
      nested
      trigger={button}
    >
      {(close) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: 0,
            height: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              height: 45,
              width: "100%",
              backgroundColor: "gray",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: 18, fontWeight: "bold", color: "white" }}>
              {title}
            </div>
          </div>
          <div
            style={{
              overflow: "scroll",
              padding: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div style={{ marginTop: 15, height: 350 }}>
              <div style={{ marginTop: 10 }}></div>

              {items.map((item, index) => (
                <PickerItem
                  {...item}
                  index={index}
                  key={index}
                  selected={selected}
                  setSelected={setSelected}
                />
              ))}
            </div>
          </div>

          <div
            style={{
              padding: 10,
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}
          >
            <Button
              className="btn-block"
              style={{
                backgroundColor: "green",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                onSubmit(selected);
                close();
              }}
            >
              Done
            </Button>
            <Button
              className="btn-block"
              style={{
                marginLeft: 15,
                backgroundColor: "red",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                close();
              }}
            >
              Cancel
            </Button>
          </div>
          <div>
            <ToastContainer />
          </div>
        </div>
      )}
    </Popup>
  );
};

const PickerItem = ({ id, title, index, setSelected, selected }) => {
  let className =
    index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
  return (
    <div
      className="item-btn"
      style={{ display: "flex", flexDirection: "column", width: 400 }}
      onClick={() => setSelected((p) => (p === id ? undefined : id))}
    >
      <div className={className} style={{ marginTop: 0 }}>
        <div className="projects-item-cat" style={{}}>
          <div style={{ fontSize: 16 }}>{title}</div>
        </div>
        <div
          className="projects-item-cat"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <input
            style={{ width: 20, height: 20 }}
            type="checkbox"
            checked={selected === id}
            onChange={() => setSelected((p) => (p === id ? undefined : id))}
            onClick={(event) => {
              event.stopPropagation();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Picker;
